export default "__VITE_ASSET__3f9d8b1f__"